import { render, staticRenderFns } from "./ReportsChart.vue?vue&type=template&id=22d609d8"
import script from "./ReportsChart.vue?vue&type=script&lang=js"
export * from "./ReportsChart.vue?vue&type=script&lang=js"
import style0 from "./ReportsChart.vue?vue&type=style&index=0&id=22d609d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports